import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
import { create } from "zustand";

interface RetailerSubUser {
  hasActiveSubUser: boolean;
  hasEverInvitedSubUser: boolean;
  hasEverHadActiveSubUser: boolean;
  setRetailerSubUser: (retailer: Partial<IRetailer>) => void;
}

export const useZustandRetailerSubUser = create<RetailerSubUser>((set) => ({
  hasActiveSubUser: false,
  hasEverInvitedSubUser: false,
  hasEverHadActiveSubUser: false,
  setRetailerSubUser: (retailer) => {
    set({
      hasActiveSubUser:
        retailer.multi_user_states?.includes(
          IRetailer.MultiUserState.HAS_ACTIVE_SUBUSER
        ) ?? false,
      hasEverInvitedSubUser:
        retailer.multi_user_states?.includes(
          IRetailer.MultiUserState.HAS_INVITED_SUBUSER
        ) ?? false,
      hasEverHadActiveSubUser:
        retailer.multi_user_states?.includes(
          IRetailer.MultiUserState.HAS_EVER_HAD_ACTIVE_SUB_USER
        ) ?? false,
    });
  },
}));

const useSubUserControl = () => {
  const { hasActiveSubUser, hasEverInvitedSubUser, hasEverHadActiveSubUser } =
    useRetailerStore([
      "hasActiveSubUser",
      "hasEverInvitedSubUser",
      "hasEverHadActiveSubUser",
    ]);

  return {
    hasActiveSubUser,
    hasEverInvitedSubUser,
    hasEverHadActiveSubUser,
  };
};

export const useSubUser = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return useZustandRetailerSubUser();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return useSubUserControl();
};
